export default function Intro() {
  return (
    <section className="py-16 bg-white border-b border-gray-100">
      <div className="max-w-3xl mx-auto text-center px-6">
        <h2 className="text-3xl font-bold text-gray-900 mb-6">
          Built for Performance. Designed for Beauty.
        </h2>
        <p className="text-lg text-gray-600 leading-relaxed">
          Our high-performance stretch tents offer unmatched versatility and style. Waterproof, UV resistant, fire rated, and easy to set up, perfect for weddings, corporate events, and festivals.
        </p>
      </div>
    </section>
  );
}
